export enum RecursosCostumizadosEnum {
    RECURSO = 'RECURSO',
    ITEM = 'ITEM',
    ETAPA = 'ETAPA',
    CONTEUDO = 'CONTEUDO',
}
